import Api2Talk from "../api2talk";

const PATH = "/providerpredefinedmessagetemplates";

const getProviderPredefinedMessageTemplates = async () => {
  const response = await Api2Talk.get(PATH);
  return response.data;
};

const updateProviderPredefinedMessageTemplates = async (items) => {
  const response = await Api2Talk.put(PATH, items);
  return response.data;
};

export {
  getProviderPredefinedMessageTemplates,
  updateProviderPredefinedMessageTemplates
};
